import { useNavigate, useParams } from 'react-router';

export enum AdminTabs {
  Users = 'users',
  Appearance = 'appearance',
  DataExportConfig = 'data-export-config',
}

export function useAdminTabs() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: AdminTabs }>();

  const setTab = (value: AdminTabs) => {
    navigate(`/admin/${value}`);
  };

  return {
    currentTab: tab,
    setTab,
  };
}
